<template>
  <v-row class="gadient-auth" align="center" justify="center" style="height: 100vh">
    <v-card class="pa-3" width="480">
      <v-card-title>
        <v-sheet width="100%">
          <img class="ml-1 my-3" :src="require('@/assets/appLogo-color--Onlight.svg')" height="48">
          <span class="d-block ml-1 mt-2 mb-1 heading-3 text--secondary font-weight-medium">Restablecer contraseña</span>
          <span class="d-block ml-1 mt-2 body-2 text--secondary">Escribe tu nueva contraseña para iniciar sesión.</span>
        </v-sheet>
      </v-card-title>
      <v-card-text>
        <v-form>
          <v-col class="pa-0">
            <span class="body-2 text--secondary font-weight-medium">Contraseña</span>
            <v-text-field class="icon-field" v-model="user.new_password1" @keyup.enter="resetPassword" :error="$v.user.new_password1.$error" @click:append="show1 = !show1" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :type="show1 ? 'user.new_password1' : 'password'" outlined hide-details required single-line dense maxlength="20" autocomplete="new-password" />
          </v-col>
          <v-col class="pa-0 my-6">
            <span class="body-2 text--secondary font-weight-medium">Contraseña</span>
            <v-text-field class="icon-field" v-model="user.new_password2" @keyup.enter="resetPassword" :error="$v.user.new_password2.$error" @click:append="show = !show" :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'" :type="show ? 'user.new_password2' : 'password'" outlined :hide-details="!$v.user.new_password2.sameAsPassword" persistent-hint required single-line dense maxlength="20" autocomplete="new-password" hint="El password debe ser igual." />
          </v-col>
          <v-col class="mt-6 pa-0">
            <v-btn @click="resetPassword" :loading="createLoader" color="primary" height="40" dark block>Restablecer contraseña</v-btn>
          </v-col>
        </v-form>
      </v-card-text>
    </v-card>
  </v-row>
</template>
<script>
import { required, sameAs, minLength } from 'vuelidate/lib/validators'
export default {
  data: () => ({
    user: {
      uid: null,
      token: null,
      new_password1: '',
      new_password2: ''
    },
    createLoader: false,
    show: false,
    show1: false
  }),
  created () {
    this.user.uid = this.$route.params.uid
    this.user.token = this.$route.params.token
  },
  methods: {
    resetPassword () {
      this.$v.user.$touch()
      if (this.$v.user.$invalid) {
        return false
      }
      this.createLoader = true
      this.$store.dispatch('auth/PASSWORD_RESET_CONFIRM', {
        uid: this.user.uid,
        token: this.user.token,
        new_password1: this.user.new_password1,
        new_password2: this.user.new_password2
      })
      .then(() => {
        this.$dialog.message.info('Se ha restablecido la contraseña, inicia sesión para continuar.')
        this.$router.push({ name: 'AuthSignIn' })
      })
      .finally(() => {
        this.createLoader = false
      })
    }
  },
  validations: {
    user: {
      new_password1: {
        required,
        minLength: minLength(8)
      },
      new_password2: {
        sameAsPassword: sameAs('new_password1')
      }
    }
  }
}
</script>